// test2646
(2646 && 0);
